import * as React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const Sort = ({ direction, stroke = 'icon.arrowBlue', fill = 'transparent', ...props }) => {
  if (direction === 'desc')
    return (
      <IconBase viewBox='0 0 16 14' {...props}>
        <Path
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          fill={fill}
          d='m1 7 3 3 3-3'
        />
      </IconBase>
    )
  if (direction === 'asc')
    return (
      <IconBase viewBox='0 0 16 4' {...props}>
        <Path
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          fill={fill}
          d='M7 4 4 1 1 4'
        />
      </IconBase>
    )

  return (
    <IconBase viewBox='0 0 16 11' {...props}>
      <Path
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
        d='m1 7 3 3 3-3'
      />
      <Path
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
        d='M7 4 4 1 1 4'
      />
    </IconBase>
  )
}

Sort.propTypes = {
  direction: PropTypes.oneOf(['asc', 'desc', false]),
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default Sort
